import React from 'react';
import { SignModal } from './sign-modal';
import { SignatureText } from './signature-text';
import { FormState } from 'formstate';
import { InputFieldState, FormValidators } from '@servicetitan/form';
import { observer } from 'mobx-react';
import { lazyInject } from 'src/signature/ioc';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';
import { FormSignatureRequestModel } from 'src/api';
import { SignatureProps } from './signature';

@observer
export class DesktopSignModal extends React.Component<SignatureProps> {
    @lazyInject(SignModalStore) private signModalStore!: SignModalStore;

    formState: FormState<{ signature: InputFieldState<string> }>;

    constructor(props: SignatureProps) {
        super(props);

        this.formState = new FormState({
            signature: new InputFieldState<string>('').validators(FormValidators.required),
        });
    }

    handleClickSubmit = () => {
        const { document } = this.props;
        this.formState.validate();
        this.signModalStore.signDocument(document, {
            signatureText: this.formState.$.signature.value,
        });
    };

    handleClickCancel = () => {
        this.formState.reset();
        this.props.handleClose();
    };

    render() {
        const { document, open } = this.props;
        const { signature } = this.formState.$;

        return (
            <SignModal
                open={open}
                signatureInput={
                    <SignatureText
                        value={signature.value}
                        onChange={signature.onChangeHandler}
                        error={signature.hasError}
                    />
                }
                signatureFieldCount={
                    (document as FormSignatureRequestModel).blankSignatureFieldCount
                }
                canSubmit={!!signature.value}
                onSubmit={this.handleClickSubmit}
                onCancel={this.handleClickCancel}
            />
        );
    }
}
